import { render, staticRenderFns } from "./ViewIncident.vue?vue&type=template&id=3110d3ab&"
import script from "./ViewIncident.vue?vue&type=script&lang=js&"
export * from "./ViewIncident.vue?vue&type=script&lang=js&"
import style0 from "./ViewIncident.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Volumes/Work/Work/gerocare/CrmWeb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports